__webpack_require__.p = "https://design-system.staging.ads-dev.sportradar.com/";